<template>
  <router-view></router-view>
</template>

<script>
import { uiHelper, locale } from '@/util'
import { ROUTE_NAME } from '@/constants/route.constants'
import { JACKPOT_AMOUNT } from '@/store/game.module'

export default {
  name: 'SlotLayout',
  metaInfo: {
    title: `${locale.getMessage('meta.slot_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content: `${locale.getMessage('meta.slot_description')}`
      },
      { name: 'keyword', content: `${locale.getMessage('meta.slot_keyword')}` }
    ]
  },
  methods: {
    getJackpotAmount() {
      this.$store.dispatch(`${JACKPOT_AMOUNT}`)
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER,
        params: { lang: this.$route.params.lang }
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    }
  }
}
</script>

<style>
.game_icon_sizing {
  border-radius: 15px !important;
}
</style>
